import { Component, Input } from '@angular/core';
import { BaseInput } from '../../../models';

@Component({
    template: '',
    standalone: true
})
export class BaseInputComponent<T = string> {
    @Input() control!: BaseInput<T>;
}
